import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7867e00e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "table matadata" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { "aria-live": "polite" }
const _hoisted_6 = {
  key: 0,
  class: "label required",
  "aria-label": "必須"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"display":"flex","gap":"0.5rem"} }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 入力されたURLの数が、アップロードされたファイルの数を超過しています。 ")
const _hoisted_13 = {
  key: 1,
  class: "different-info-space"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButtonList = _resolveComponent("RadioButtonList")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_PlusInput = _resolveComponent("PlusInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metadataList, (data, index) => {
        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
          _hoisted_3,
          (data.sortNo)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                _createElementVNode("th", _hoisted_5, [
                  _createTextVNode(_toDisplayString(data.screenItemName) + " ", 1),
                  (data.minimum === '1')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "必須 "))
                    : _createCommentVNode("", true)
                ]),
                (data.radioButton)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_RadioButtonList, {
                          modelValue: data.value[0],
                          "onUpdate:modelValue": ($event: any) => ((data.value[0]) = $event),
                          items: _ctx.convertRadioList(data.radioButton),
                          id: 'radio',
                          name: "radio-permission"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                      ]),
                      _createElementVNode("p", {
                        class: "text-description",
                        innerHTML: data.description
                      }, null, 8, _hoisted_9),
                      (_ctx.isNotSelected(data.radioButton, data.value[0]))
                        ? (_openBlock(), _createBlock(_component_TextAlert, {
                            key: 0,
                            class: _normalizeClass('errMsg-' + data.id)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.screenItemName) + "を入力してください。 ", 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                      (data.maximum === '1')
                        ? (_openBlock(), _createBlock(_component_AppInput, {
                            key: 0,
                            modelValue: data.value[0],
                            "onUpdate:modelValue": ($event: any) => ((data.value[0]) = $event),
                            onBlur: ($event: any) => (_ctx.blur(data.id)),
                            label: data.screenItemName,
                            inputId: `input-metadata-${index + 1}`
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "label", "inputId"]))
                        : (_openBlock(), _createBlock(_component_PlusInput, {
                            key: 1,
                            modelValue: data.value,
                            "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                            label: data.screenItemName,
                            onBlur: ($event: any) => (_ctx.blur(data.id))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onBlur"])),
                      _createElementVNode("p", {
                        class: "text-description",
                        innerHTML: data.description
                      }, null, 8, _hoisted_11),
                      (data.minimum === '1' && data.value[0] === '' && (_ctx.blurList.includes(data.id) || _ctx.requiredFlag))
                        ? (_openBlock(), _createBlock(_component_TextAlert, {
                            key: 2,
                            class: _normalizeClass('errMsg-' + data.id)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.screenItemName) + "を入力してください。 ", 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : _createCommentVNode("", true),
                      (data.id == '701' && _ctx.isInvalidContentsUriNum(data.value))
                        ? (_openBlock(), _createBlock(_component_TextAlert, {
                            key: 3,
                            class: _normalizeClass('errMsg-' + data.id + '-numCheck')
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (data.id === '277')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}